import { SVGProps } from "react"

const Successful = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 55" fill="none" {...props}>
      <g clipPath="url(#clip0_8095_318276)">
        <path
          d="M53.9994 27.4997L51.4987 30.7268L53.0858 34.4889L49.833 36.9573L50.3856 41.0023L46.6032 42.5406L46.0917 46.5917L42.0406 47.1032L40.5023 50.8856L36.4567 50.333L33.9889 53.5858L30.2268 51.9987L26.9997 54.4994L23.7727 51.9987L20.0105 53.5858L17.5427 50.333L13.4971 50.8856L11.9589 47.1032L7.90774 46.5917L7.39627 42.5406L3.61381 41.0023L4.16648 36.9567L0.913615 34.4889L2.50132 30.7268L0 27.4997L2.50132 24.2727L0.913615 20.5105L4.16648 18.0427L3.61381 13.9971L7.39627 12.4589L7.90829 8.40774L11.9594 7.89627L13.4977 4.11381L17.5427 4.66648L20.0105 1.41362L23.7727 3.00132L26.9997 0.5L30.2268 3.00132L33.9889 1.41362L36.4573 4.66648L40.5023 4.11381L42.0406 7.89627L46.0917 8.40829L46.6032 12.4594L50.3856 13.9977L49.833 18.0427L53.0858 20.5105L51.4987 24.2727L53.9994 27.4997Z"
          fill="#2EB758"
        />
        <path
          d="M21.9625 38.1548L15.9336 32.1254L18.1849 29.8741L21.8433 33.5324L35.7612 18.0938L38.1263 20.2253L21.9625 38.1548Z"
          fill="white"
        />
      </g>
    </svg>
  )
}
export default Successful
